import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { ThemeProvider, CssBaseline } from '@mui/material';

import { SnackbarProvider } from 'notistack';
import SessionTimeout from './components/session-tracker/session-tracker';
import { store } from "./store/store"
import GetTheme from './theme';
import Messages from './Messages'
import Pages from './pages';


const theme = GetTheme();
const Main = () => (
    <Provider store={store}>
        <SessionTimeout />
        <BrowserRouter>
            <SnackbarProvider maxSnack={4} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Pages />
                </ThemeProvider>
                <Messages />
            </SnackbarProvider>
        </BrowserRouter>
    </Provider>
)

export default Main;
